export const FALLBACK_TPA_SETTINGS = {
    ampEnabled: false,
    allPostsFeedLabel: 'All Posts',
    comments: {
        enabled: false,
        anonymousEnabled: false,
        ratingsEnabled: false,
        ratingsMandatory: false,
    },
    liveSiteEditingDeprecated: false,
};
//# sourceMappingURL=fallback-tpa-settings.js.map